import React, { useState, useEffect } from 'react';
import './EmailComposer.css';

const EmailComposer = ({ templates, onChange, selectedCount }) => {
  const [formData, setFormData] = useState({
    name: '',
    templateId: '',
    subject: '',
    customContent: ''
  });
  
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [previewMode, setPreviewMode] = useState(false);
  
  useEffect(() => {
    onChange(formData);
  }, [formData]);
  
  const handleTemplateChange = (templateId) => {
    const template = templates.find(t => t.id === templateId);
    setSelectedTemplate(template);
    setFormData(prev => ({
      ...prev,
      templateId,
      subject: template ? template.subject : ''
    }));
  };
  
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  
  const getPreviewVariables = () => {
    return {
      nome: 'João Silva',
      precatorios: '12345, 67890',
      conteudo_personalizado: formData.customContent || 'Conteúdo personalizado aparecerá aqui',
      link_acao: '#',
      texto_botao: 'Acessar Sistema',
      unsubscribe_link: '#'
    };
  };
  
  return (
    <div className="email-composer-container">
      <h3>Compor Email</h3>
      
      <div className="form-group">
        <label htmlFor="campaign-name">Nome da Campanha *</label>
        <input
          type="text"
          id="campaign-name"
          value={formData.name}
          onChange={(e) => handleInputChange('name', e.target.value)}
          placeholder="Ex: Notificação Precatórios MT - Janeiro 2024"
          className="form-input"
          required
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="template">Template de Email *</label>
        <select
          id="template"
          value={formData.templateId}
          onChange={(e) => handleTemplateChange(e.target.value)}
          className="form-select"
          required
        >
          <option value="">Selecione um template</option>
          {templates.map(template => (
            <option key={template.id} value={template.id}>
              {template.name}
            </option>
          ))}
        </select>
        {selectedTemplate && (
          <p className="template-description">{selectedTemplate.description}</p>
        )}
      </div>
      
      <div className="form-group">
        <label htmlFor="subject">Assunto do Email *</label>
        <input
          type="text"
          id="subject"
          value={formData.subject}
          onChange={(e) => handleInputChange('subject', e.target.value)}
          placeholder="Assunto do email"
          className="form-input"
          required
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="custom-content">Conteúdo Personalizado</label>
        <textarea
          id="custom-content"
          value={formData.customContent}
          onChange={(e) => handleInputChange('customContent', e.target.value)}
          placeholder="Digite aqui o conteúdo personalizado que será inserido no template..."
          className="form-textarea"
          rows="6"
        />
        <p className="field-hint">
          Este conteúdo será inserido na seção personalizada do template selecionado.
        </p>
      </div>
      
      {selectedTemplate && (
        <div className="template-variables">
          <h4>Variáveis Disponíveis</h4>
          <div className="variables-grid">
            {selectedTemplate.variables.map(variable => (
              <div key={variable} className="variable-item">
                <code>{`{{${variable}}}`}</code>
              </div>
            ))}
          </div>
          <p className="variables-hint">
            Estas variáveis serão automaticamente substituídas pelos dados do destinatário.
          </p>
        </div>
      )}
      
      <div className="preview-section">
        <button 
          type="button"
          className="preview-button"
          onClick={() => setPreviewMode(!previewMode)}
          disabled={!formData.templateId}
        >
          {previewMode ? 'Ocultar Preview' : 'Visualizar Preview'}
        </button>
        
        {previewMode && formData.templateId && (
          <div className="email-preview">
            <div className="preview-header">
              <strong>Preview do Email</strong>
              <span className="preview-note">Este é um exemplo de como o email será exibido</span>
            </div>
            <div className="preview-content">
              <div className="preview-subject">
                <strong>Assunto:</strong> {formData.subject || 'Sem assunto'}
              </div>
              <iframe
                srcDoc={getEmailPreviewHTML()}
                style={{ width: '100%', height: '400px', border: '1px solid #ddd' }}
                title="Email Preview"
              />
            </div>
          </div>
        )}
      </div>
      
      <div className="recipient-info">
        <div className="info-icon">ℹ️</div>
        <div>
          <strong>{selectedCount}</strong> destinatário(s) selecionado(s)
          {selectedCount === 0 && (
            <span className="warning-text"> - Selecione pelo menos um destinatário</span>
          )}
        </div>
      </div>
    </div>
  );
  
  function getEmailPreviewHTML() {
    // This would normally come from the backend, but for now we'll use a simple preview
    const vars = getPreviewVariables();
    let html = `
      <html>
        <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
          <div style="max-width: 600px; margin: 0 auto; padding: 20px;">
            <h2 style="color: #1a365d;">MICA CAPITAL</h2>
            <p>Prezado(a) <strong>${vars.nome}</strong>,</p>
            <p>Gostaríamos de informar sobre atualizações importantes relacionadas ao(s) seu(s) precatório(s).</p>
            <p><strong>Precatório(s):</strong> ${vars.precatorios}</p>
            <div style="background: #f8f9fa; padding: 15px; margin: 20px 0; border-left: 3px solid #3498db;">
              ${vars.conteudo_personalizado}
            </div>
            <p style="text-align: center; margin: 30px 0;">
              <a href="${vars.link_acao}" style="background: #3182ce; color: white; padding: 12px 30px; text-decoration: none; border-radius: 5px;">
                ${vars.texto_botao}
              </a>
            </p>
            <p>Atenciosamente,<br>Equipe MICA CAPITAL</p>
          </div>
        </body>
      </html>
    `;
    return html;
  }
};

export default EmailComposer;